import type { DailyFactHero } from '../models/daily-fact-hero.model';

/** Public HTTPS URLs for the same robocat assets as ai-daily-fact-worker `daily-fact-heroes.preset`. */
const B = 'https://storage.googleapis.com/valvur-dev-run-bucket/presets/robocats';

/**
 * Video persona presets for daily-fact videos and VALVUR course video generation.
 * One row per robocat (`name`); `GenerateVideoRequestDto.presetId` uses this `name`.
 */
export const VIDEO_HERO_PRESETS: ReadonlyArray<{
  name: string;
  imageUrl: string;
}> = [
  { name: 'Ajato', imageUrl: `${B}/sage.png` },
  { name: 'Tarku', imageUrl: `${B}/researcher.png` },
  { name: 'Tarka', imageUrl: `${B}/thinker.png` },
  { name: 'Lennu', imageUrl: `${B}/traveler.png` },
  { name: 'Kassi', imageUrl: `${B}/empathic.png` },
  { name: 'Tuge', imageUrl: `${B}/sportsman.png` },
];

export function videoPresetToDailyFactHero(
  preset: (typeof VIDEO_HERO_PRESETS)[number],
): DailyFactHero {
  return {
    id: preset.name,
    name: preset.name,
    imageUrl: preset.imageUrl,
  };
}
